// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PracticeLocationAccessCodeResponse } from './practice-location-access-code-response';

/** See com.rev360.pms.api.controller.admin.general.location.AdminPracticeLocationPhrResponse */
/* istanbul ignore next */
@GandalfModel
export class AdminPracticeLocationPhrResponse extends GandalfModelBase {

	@GandalfArray(PracticeLocationAccessCodeResponse)
	accessCodes!: PracticeLocationAccessCodeResponse[] | null;

	@GandalfProperty({ designType: Boolean })
	allowContactLensOrdering!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	allowPhrScheduling!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	allowRegisterPhrScheduling!: boolean | null;

	@GandalfArray(Number)
	availableForMessagingEmployeeIds!: number[] | null;

	@GandalfArray(Number)
	patientOrderNotificationPersonIds!: number[] | null;

	@GandalfArray(Number)
	patientScheduleNotificationPersonIds!: number[] | null;

	@GandalfArray(Number)
	patientUpdateNotificationPersonIds!: number[] | null;

	@GandalfProperty({ designType: Number })
	phrLogoFileId!: number | null;

	@GandalfConstantDecorator(constants.PhrShipToType)
	@GandalfProperty({ designType: constants.PhrShipToType })
	phrShipToType!: constants.PhrShipToType | null;

	@GandalfProperty({ designType: String })
	phrUrlCode!: string | null;

	@GandalfProperty({ designType: Number })
	primaryColor!: number | null;

	@GandalfArray(Number)
	registrationNotificationPersonIds!: number[] | null;

	@GandalfArray(Number)
	registrationScheduleNotificationPersonIds!: number[] | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	shippingFee!: number | null;

	@GandalfProperty({ designType: Number })
	textColor!: number | null;

}
